import moment from 'moment';

export default (start, end, lang) => `${moment(start).
  locale(lang.toLowerCase()).
  format('HH:mm')} - ${moment(end).
  locale(lang.toLowerCase()).
  format('HH:mm')}`;